import config from '../../config';
import { getFableticsEntitlement, userCanAccessGlobalPrivileges } from './user';

const globalPrivilegesUrl = `${config.apiHost}/v1/saml/globalprivileges`;

const TPR_HANDLERS = {
    fl: (user) => getFableticsEntitlement(user)?.ctaUrl || null,
    gp: (user) => (userCanAccessGlobalPrivileges(user) ? globalPrivilegesUrl : null),
};

// Returns the absolute URL to navigate to in the same tab, or null when the
// caller should fall through to the existing redirect chain
// (next / redirect / home). When `tpr` is recognized but the user doesn't
// qualify, returns '/home' per product spec — partner pages send users to
// "/login?tpr=…" expecting either the partner destination or a graceful
// landing in UTR.
export const resolveThirdPartyRedirect = (tpr, user) => {
    const handler = TPR_HANDLERS[tpr];
    if (!handler) {
        return null;
    }
    return handler(user) || '/home';
};
